import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Common } from 'app/modules/_common/service';

@Injectable({providedIn: 'root'})
export class Settings
{
    get BASEURL(): string
    {
        return environment.api.replace("[hostinglocation]", AuthUtils.hostingLocation) + '/api/v2/';
    }

    constructor(private _httpClient: HttpClient)
    {
    }

    private _getSettingsBooking: BehaviorSubject<any | null> = new BehaviorSubject(null);
    get getSettingsBooking$(): Observable<any> {
        return this._getSettingsBooking.asObservable();
    }
    public getSettingsBooking() {
        return this._httpClient.get<any>(`${this.BASEURL}settings/booking`).pipe(
            catchError(Common.CatchError),
            map((data) => {

                this._getSettingsBooking.next(data);

                return data;
            })
        );
    }

    private _getSettingsPeople: BehaviorSubject<any | null> = new BehaviorSubject(null);
    get getSettingsPeople$(): Observable<any> {
        return this._getSettingsPeople.asObservable();
    }
    public getSettingsPeople() {
        return this._httpClient.get<any>(`${this.BASEURL}preference/getSettings/preferencepeople`).pipe(
            catchError(Common.CatchError),
            map((data) => {
                this._getSettingsPeople.next(data);

                return data;
            })
        );
    }

    private _getSettingsPersonStatus: BehaviorSubject<any | null> = new BehaviorSubject(null);
    get getSettingsPersonStatus$(): Observable<any> {
        return this._getSettingsPersonStatus.asObservable();
    }
    public getSettingsPersonStatus() {
        return this._httpClient.get<any>(`${this.BASEURL}preference/getSettings/preferencepersonstatus`).pipe(
            catchError(Common.CatchError),
            map((data) => {
                this._getSettingsPersonStatus.next(data);

                return data;
            })
        );
    }
}
